module.exports = __webpack_public_path__ + "img/top3.30901523.png";